export async function uploadSpaceGameQuestionsCSV({ file, token }) {
  const formData = new FormData();
  formData.append("csv", file);

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/uploadSpaceGameQuestionsCSV`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token || ""}`,
    },
    body: formData,
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to upload CSV");
  }
  return data;
}
